import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getCookie } from 'typescript-cookie'
import CategoriesBigButtons, { CategoryProps } from "../components/bigButton/CategoriesBigButtons";
import H1TitleId from "../components/title/H1TitleId";
import H2TitleId from "../components/title/H2TitleId";
import BannerCarousel from "../components/banner/BannerCarousel";
import Centered from "../components/util/Centered";
import PageContent from "../components/util/PageContent";
import { HcContext, SizeOfWindow } from "../types/hccontext";
import GetStrLocalized from "../datas/GetStrLocalized";
import { createErrorModalContent } from "../props/ModalContentProps";
import { VerseToDisplayProps } from "../props/versetodisplayprops";
import H2Title from '../components/title/H2Title'
import ReadingContent from '../components/util/ReadingContent'


interface HomeProps {
	language: string;
	hcContext: HcContext;
	backendUrl: string;
	searchValue: string;
	useMicrophone: boolean;
};


export class HomeGetContentType {
	language: string;
	messageIds: string[];
	allRecommendationIds: string[];

	constructor(
		language: string,
		messageIds: string[],
		allRecommendationIds: string[]) {
		this.language = language;
		this.messageIds = messageIds;
		this.allRecommendationIds = allRecommendationIds;
	}
}

interface AReadingProps {
	title: string;
	subTitle: string;
	referenceUrl: string;
	reference: string;
	content: VerseToDisplayProps[];
}


interface ExternalLink {
	title: string;
	url: string;
}

interface MassProps {
	name: string;
	readings: AReadingProps[];
}

interface MassesRequestProps {
	title: string;
	externalLinks: ExternalLink[];
	masses: MassProps[];
}



function Home({ language, hcContext, backendUrl, searchValue, useMicrophone }: Readonly<HomeProps>) {

	useEffect(() => {
		hcContext.setDocumentTitle("Holy Chatter");
	}, [hcContext]);

	const location = useLocation();
	const [smallNbOfVideoForShortScreen, setSmallNbOfVideoForShortScreen] = useState(true)
	const [lastPath, setLastPath] = useState("")
	const [request, setRequest] = useState({ recommendations: [], categories: [], recentVideos: [], recentChatMessages: [] })
	const [massesRequest, setMassesRequest] = useState<MassesRequestProps>({ title: "", externalLinks: [], masses: [] });
	const messageIdsCookie = getCookie('messageIds')
	const allRecommendationIdsCookie = getCookie('allRecommendationIds')
	let categories: CategoryProps[] = [
		{
			nb: undefined, type: "", id: "", link: "/fr/chatbot", image: "/buttons/chatbot_phone_laptop.png",
			duration: "", title: "Chatbot chrétien", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
		},
		{
			nb: undefined, type: "", id: "", link: GetStrLocalized("fr", "readingsFolderName") + "/" + GetStrLocalized("fr", "bibleFolderName"), image: "/buttons/bible.jpg",
			duration: "", title: "Bible", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
		},
		{
			nb: undefined, type: "", id: "", link: "/fr/categories/raisons-de-croire", image: "/buttons/penser.jpg",
			duration: "", title: "Raisons de croire", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
		},
		{
			nb: undefined, type: "", id: "", link: "/fr/categories/temoignages", image: "/buttons/prises_de_parole.jpeg",
			duration: "", title: "Témoignages", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
		},
		{
			nb: undefined, type: "", id: "", link: "/fr/categories/decouverte", image: "/buttons/discover.jpg",
			duration: "", title: "Découverte", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
		},
		{
			nb: undefined, type: "", id: "", link: "/fr/categories/solidarite-3", image: "/buttons/solidarite.jpg",
			duration: "", title: "Solidarité", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
		},
		{
			nb: undefined, type: "", id: "", link: "/fr/categories/enseignements", image: "/buttons/teachings.jpeg",
			duration: "", title: "Enseignements", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
		},
		{
			nb: undefined, type: "", id: "", link: "/fr/categories/eglise", image: "/buttons/church.jpg",
			duration: "", title: "Eglise", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
		},
		{
			nb: undefined, type: "", id: "", link: "/fr/categories/prieres", image: "/buttons/prier.jpg",
			duration: "", title: "Prières", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
		},
		{
			nb: undefined, type: "", id: "", link: "/fr/categories/personnes-memorables", image: "/buttons/person.jpg",
			duration: "", title: "Personnes mémorables", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
		},
		{
			nb: undefined, type: "", id: "", link: "/fr/categories/humour", image: "/buttons/laugh.png",
			duration: "", title: "Humour", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
		},
		{
			nb: undefined, type: "", id: "", link: "/fr/categories/dieu", image: "/buttons/god.jpg",
			duration: "", title: "Dieu", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
		}
	]

	if (language === "en") {
		categories = [
			{
				nb: undefined, type: "", id: "", link: "/en/categories/reasons-to-believe", image: "/buttons/penser.jpg",
				duration: "", title: "Reasons to believe", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
			},
			{
				nb: undefined, type: "", id: "", link: "/en/categories/testimonies", image: "/buttons/prises_de_parole.jpeg",
				duration: "", title: "Testimonies", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
			},
			{
				nb: undefined, type: "", id: "", link: GetStrLocalized("en", "readingsFolderName") + "/" + GetStrLocalized("en", "bibleFolderName"), image: "/buttons/bible.jpg",
				duration: "", title: "Bible", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
			},
			{
				nb: undefined, type: "", id: "", link: "/en/categories/discovery", image: "/buttons/discover.jpg",
				duration: "", title: "Discovery", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
			},
			{
				nb: undefined, type: "", id: "", link: "/en/categories/solidarity", image: "/buttons/solidarite.jpg",
				duration: "", title: "Solidarity", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
			},
			{
				nb: undefined, type: "", id: "", link: "/en/categories/teachings", image: "/buttons/teachings.jpeg",
				duration: "", title: "Teachings", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
			},
			{
				nb: undefined, type: "", id: "", link: "/en/categories/church", image: "/buttons/church.jpg",
				duration: "", title: "Church", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
			},
			{
				nb: undefined, type: "", id: "", link: "/en/categories/prayers", image: "/buttons/prier.jpg",
				duration: "", title: "Prayers", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
			},
			{
				nb: undefined, type: "", id: "", link: "/en/categories/memorable-people", image: "/buttons/person.jpg",
				duration: "", title: "Memorable people", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
			},
			{
				nb: undefined, type: "", id: "", link: "/en/categories/humor", image: "/buttons/laugh.png",
				duration: "", title: "Humor", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
			},
			{
				nb: undefined, type: "", id: "", link: "/en/categories/god", image: "/buttons/god.jpg",
				duration: "", title: "God	", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
			},
			{
				nb: undefined, type: "", id: "", link: "/en/categories/heaven", image: "/buttons/paradis.jpeg",
				duration: "", title: "Heaven", subTitle: "", sourceName: "", sourceImage: "", stars: undefined
			}
		]
	}

	if (location.pathname !== lastPath) {
		setLastPath(location.pathname);
		const messageIdsCookieVector = messageIdsCookie?.split("|")
		const allRecommendationIdsCookieVector = allRecommendationIdsCookie?.split("|")
		const postContent = new HomeGetContentType(language, messageIdsCookieVector ?? [],
			allRecommendationIdsCookieVector ?? [])

        let dateFolder = ""
		fetch(backendUrl + "/readings_of_the_day_content_json?l=" + language + "&r=gospel&d=" + dateFolder)
			.then(res => res.json())
			.then(jsonData => {
				if (jsonData.errorMessage) {
					console.error(jsonData.errorMessage)
					return
				}
				setMassesRequest(jsonData);
			})
			.catch(rejected => {
				console.error(rejected.message)
			});


		fetch(hcContext.backendUrl + "/home_content", {
			method: 'POST',
			body: JSON.stringify(postContent),
			headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
		})
			.then(res => res.json())
			.then(jsonData => {
				if (jsonData.errorMessage) {
					hcContext.setError(createErrorModalContent(language, jsonData.errorMessage))
					return
				}
				setRequest(jsonData)
			})
			.catch(rejected => {
				hcContext.setError(createErrorModalContent(language, rejected.message))
			});
	}

	return (
		<>
			<BannerCarousel language={language} hcContext={hcContext} searchValue={searchValue} useMicrophone={useMicrophone} />
			<PageContent marginTop={0}>

				<H2TitleId language={language} titleId="categories" isDarkTheme={hcContext.isDarkTheme} />
				<CategoriesBigButtons categories={categories} hcContext={hcContext} />
				<br />

				<br />
				{
					massesRequest &&
					massesRequest.masses.length > 0 &&
					<>
						{
							massesRequest.masses.map((mass, massIndex) => {

								return (
									<div key={"mass-" + massIndex}>
										{
											mass &&
											mass.readings.length > 0 &&
											<>
												{
													mass.readings.map((reading, readingIndex) => {
														return (
															<React.Fragment key={"reading-" + massIndex + "-" + readingIndex}>
																<H2Title isDarkTheme={hcContext.isDarkTheme}><span dangerouslySetInnerHTML={{ __html: reading.title }}></span></H2Title>
																<br />
																<div style={{ marginLeft: 40 }}>
																	<div className='hc-content-text' style={{ paddingLeft: '15px' }}>

																		<br />
																		<a href={reading.referenceUrl}>{reading.reference}</a>
																		<br />
																		<span dangerouslySetInnerHTML={{ __html: reading.subTitle }}></span>
																	</div>
																	<br /><br />
																	<ReadingContent language={language} type="bible" content={reading.content} allowToDisplayLinkFromCorpus={hcContext.userAsRightsToModifyTheContent} hcContext={hcContext} />
																</div>
																<br />
															</React.Fragment>
														)
													})
												}
											</>
										}
									</div>
								)

							})
						}
					</>
				}

				<H2TitleId language={language} titleId="novelties" isDarkTheme={hcContext.isDarkTheme} />
				<CategoriesBigButtons beginOfKey="recent-videos-" categories={request.recentVideos} hcContext={hcContext} />
				<br />

				<H2TitleId language={language} titleId="recommendations" isDarkTheme={hcContext.isDarkTheme} />
				<CategoriesBigButtons categories={request.recommendations} numberOfCategoriesToDisplay={hcContext.sizeOfWindow === SizeOfWindow.VERY_SHORT && smallNbOfVideoForShortScreen ? 2 : 100} hcContext={hcContext} />
				<br />

				{
					hcContext.sizeOfWindow === SizeOfWindow.VERY_SHORT &&
					<div className="hc-content-text">
						<Centered>
							{
								smallNbOfVideoForShortScreen ?
									<span onClick={() => setSmallNbOfVideoForShortScreen(false)} className="hc-clickable">Voir plus de vidéos</span>
									:
									<span onClick={() => setSmallNbOfVideoForShortScreen(true)} className="hc-clickable">Voir moins de vidéos</span>
							}
						</Centered>
						<br />
					</div>
				}

			</PageContent>
		</>
	)
}



export default Home;